"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.revertToRevision = exports.fetchRevisions = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _constants = require("composer-lib/lib/constants");

var _utils = require("composer-lib/lib/utils");

var _composer = require("./composer");

var _sessionManagersHelpers = require("composer-lib/lib/helpers/sessionManagersHelpers");

var _immutable = require("immutable");

var getCompositionManager = function getCompositionManager(session) {
  return (0, _sessionManagersHelpers.getManagerWithSession)('composition', session);
};

var fetchRevisionsPending = (0, _utils.createAction)(_ActionTypes.default.FETCH_REVISIONS_PENDING);
var fetchRevisionsSucceeded = (0, _utils.createAction)(_ActionTypes.default.FETCH_REVISIONS_SUCCEEDED);
var fetchRevisionsFailed = (0, _utils.createAction)(_ActionTypes.default.FETCH_REVISIONS_FAILED);

var fetchRevisions = function fetchRevisions(compositionId, session) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return function (dispatch) {
    var compositionManager = getCompositionManager(session);
    dispatch(fetchRevisionsPending());
    compositionManager.fetchRevisions(compositionId, offset).then(function (resp) {
      dispatch(fetchRevisionsSucceeded({
        objects: resp.objects,
        offset: offset
      }));
    }, function (resp) {
      dispatch(fetchRevisionsFailed(resp));
    });
  };
};

exports.fetchRevisions = fetchRevisions;
var revertToRevisionPending = (0, _utils.createAction)(_ActionTypes.default.REVISION_REVERT_PENDING);
var revertToRevisionSucceeded = (0, _utils.createAction)(_ActionTypes.default.REVISION_REVERT_SUCCEEDED);
var revertToRevisionFailed = (0, _utils.createAction)(_ActionTypes.default.REVISION_REVERT_FAILED);

var revertToRevision = function revertToRevision(compositionId, versionId, session) {
  return function (dispatch) {
    dispatch(revertToRevisionPending({}, (0, _defineProperty2.default)({}, _constants.TRACK_EVENT_META_KEY, {
      action: 'revert-composition',
      name: _constants.AmplitudeEvents.COMPOSITION_INTERACTION.USAGE
    })));
    var data = (0, _immutable.Map)({
      compositionId: compositionId,
      versionId: versionId
    });
    getCompositionManager(session).revertToRevision(data).then(function () {
      dispatch(revertToRevisionSucceeded());
      dispatch((0, _composer.fetchFullComposition)(compositionId, session));
    }, function () {
      dispatch(revertToRevisionFailed());
    });
  };
};

exports.revertToRevision = revertToRevision;